import { render, staticRenderFns } from "./SvnEditPersonal.vue?vue&type=template&id=b2a1bfd0&scoped=true&"
import script from "./SvnEditPersonal.vue?vue&type=script&lang=js&"
export * from "./SvnEditPersonal.vue?vue&type=script&lang=js&"
import style0 from "./SvnEditPersonal.vue?vue&type=style&index=0&id=b2a1bfd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a1bfd0",
  null
  
)

export default component.exports